// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-dark: #2563eb;
  --secondary-color: #10b981;
  --secondary-dark: #059669;
  --text-color: #374151;
  --text-light: #6b7280;
  --border-color: #e5e7eb;
  --bg-light: #f9fafb;
  --bg-medium: #f3f4f6;
  --bg-dark: #e5e7eb;
}

.hier-modal-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 1rem;
}

.hier-modal {
  background: #ffffff;
  border-radius: 0.75rem;
  width: 100%;
  max-width: 600px;
  max-height: 85vh;
  overflow: hidden;
  padding: 1.5rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.hier-modal h2 {
  font-weight: 800;
  font-size: 1.4rem;
  text-align: center;
  margin-bottom: 1rem;
  color: var(--primary-color);
  -webkit-user-select: none;
          user-select: none;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid var(--border-color);
}
.hier-modal .hier-modal-content {
  flex-grow: 1;
  overflow-y: auto;
  padding-right: 0.75rem;
  padding-bottom: 1rem;
  color: var(--text-color);
  font-size: 0.95rem;
}
.hier-modal .hier-modal-content::-webkit-scrollbar-track {
  background: var(--bg-medium);
  border-radius: 10px;
}
.hier-modal .hier-modal-content::-webkit-scrollbar-thumb {
  background: var(--primary-color);
  border-radius: 10px;
  height: 8px;
}
.hier-modal .hier-modal-content::-webkit-scrollbar-thumb:hover {
  background: var(--primary-dark);
}
.hier-modal .hier-modal-content .tree-node {
  position: relative;
  padding-left: 1.5rem;
  margin-bottom: 0.25rem;
}
.hier-modal .hier-modal-content .tree-node:last-child {
  margin-bottom: 0;
}
.hier-modal .hier-modal-content .tree-node .node-content {
  display: flex;
  align-items: center;
  background-color: var(--bg-light);
  padding: 0.5rem 0.75rem;
  border-radius: 0.375rem;
  border: 1px solid var(--border-color);
  transition: background-color 0.2s ease, border-color 0.2s ease;
  min-height: 40px;
}
.hier-modal .hier-modal-content .tree-node .node-content:hover {
  background-color: var(--bg-medium);
  border-color: var(--primary-color);
}
.hier-modal .hier-modal-content .tree-node .expand-icon {
  width: 1rem;
  height: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-right: 0.5rem;
  color: var(--text-light);
  transition: transform 0.2s ease;
  flex-shrink: 0;
}
.hier-modal .hier-modal-content .tree-node .expand-icon svg {
  width: 100%;
  height: 100%;
}
.hier-modal .hier-modal-content .tree-node .expand-icon.expanded {
  transform: rotate(90deg);
}
.hier-modal .hier-modal-content .tree-node .node-label {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  flex-grow: 1;
}
.hier-modal .hier-modal-content .tree-node .node-label input[type=checkbox] {
  cursor: pointer;
  accent-color: var(--primary-color);
  border-radius: 4px;
  flex-shrink: 0;
}
.hier-modal .hier-modal-content .tree-node .node-label .node-name {
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  color: #374151;
  text-overflow: ellipsis;
  flex-grow: 1;
}
.hier-modal .hier-modal-content .tree-node .node-label .node-role {
  background: var(--secondary-color);
  color: #374151;
  font-size: 0.7rem;
  font-weight: 600;
  padding: 0.2rem 0.6rem;
  border-radius: 9999px;
  -webkit-user-select: none;
          user-select: none;
  flex-shrink: 0;
}
.hier-modal .hier-modal-content .tree-node .node-children {
  margin-left: 1.5rem;
  padding-left: 1rem;
  border-left: 1px dashed var(--border-color);
  margin-top: 0.25rem;
}
.hier-modal .hier-modal-content .tree-node::before {
  content: "";
  position: absolute;
  left: 0.75rem;
  top: 1.25rem;
  width: 0.75rem;
  height: 1px;
  background-color: var(--border-color);
}
.hier-modal .hier-modal-content .tree-node .node-children > .tree-node::before {
  background-color: var(--border-color);
}
.hier-modal .hier-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding-top: 1rem;
  border-top: 1px solid var(--border-color);
}
.hier-modal .hier-modal-actions button {
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  font-weight: 700;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background-color 0.25s ease, transform 0.1s ease;
}
.hier-modal .hier-modal-actions button:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.hier-modal .hier-modal-actions .hier-modal-submit-btn {
  background-color: var(--primary-color);
  color: white;
}
.hier-modal .hier-modal-actions .hier-modal-close-btn {
  background-color: #6c757d;
  color: white;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .hier-modal-overlay .hier-modal {
    padding: 1.25rem;
  }
  .hier-modal-overlay .hier-modal h2 {
    font-size: 1.5rem;
  }
}
@media (max-width: 480px) {
  .hier-modal-overlay .hier-modal {
    padding: 1rem;
    margin: 0.75rem;
  }
  .hier-modal-overlay .hier-modal h2 {
    font-size: 1.3rem;
  }
  .hier-modal-overlay .hier-modal .hier-modal-actions {
    flex-direction: column;
    gap: 0.75rem;
  }
  .hier-modal-overlay .hier-modal .hier-modal-actions button {
    width: 100%;
    min-width: unset;
  }
  .hier-modal-overlay .hier-modal .hier-modal-content .tree-node {
    padding-left: 1rem;
  }
  .hier-modal-overlay .hier-modal .hier-modal-content .tree-node .expand-icon {
    margin-right: 0.25rem;
  }
  .hier-modal-overlay .hier-modal .hier-modal-content .tree-node .node-label {
    gap: 0.5rem;
  }
  .hier-modal-overlay .hier-modal .hier-modal-content .tree-node .node-children {
    margin-left: 1rem;
    padding-left: 0.75rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/HierarchyModal/HierarchyModal.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,0BAAA;EACA,yBAAA;EACA,qBAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,QAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;AACF;;AAEA;EACE,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,2CAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AACF;AACE;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,2BAAA;EACA,yBAAA;UAAA,iBAAA;EACA,sBAAA;EACA,4CAAA;AACJ;AAEE;EACE,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,oBAAA;EACA,wBAAA;EACA,kBAAA;AAAJ;AAQI;EACE,4BAAA;EACA,mBAAA;AANN;AASI;EACE,gCAAA;EACA,mBAAA;EACA,WAAA;AAPN;AASM;EACE,+BAAA;AAPR;AAWI;EACE,kBAAA;EACA,oBAAA;EACA,sBAAA;AATN;AAWM;EACE,gBAAA;AATR;AAYM;EACE,aAAA;EACA,mBAAA;EACA,iCAAA;EACA,uBAAA;EACA,uBAAA;EACA,qCAAA;EACA,8DAAA;EACA,gBAAA;AAVR;AAYQ;EACE,kCAAA;EACA,kCAAA;AAVV;AAcM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,oBAAA;EACA,wBAAA;EACA,+BAAA;EACA,cAAA;AAZR;AAcQ;EACE,WAAA;EACA,YAAA;AAZV;AAeQ;EACE,wBAAA;AAbV;AAiBM;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;AAfR;AAiBQ;EAGE,eAAA;EACA,kCAAA;EACA,kBAAA;EACA,cAAA;AAjBV;AAoBQ;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,YAAA;AAlBV;AAqBQ;EACE,kCAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,qBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,cAAA;AAnBV;AAuBM;EACE,mBAAA;EACA,kBAAA;EACA,2CAAA;EACA,mBAAA;AArBR;AAyBM;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,qCAAA;AAvBR;AA6BM;EACE,qCAAA;AA3BR;AAgCE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,iBAAA;EACA,yCAAA;AA9BJ;AAgCI;EACE,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,4DAAA;AA9BN;AAgCM;EACE,wBAAA;EACA,wCAAA;AA9BR;AAkCI;EACE,sCAAA;EACA,YAAA;AAhCN;AAmCI;EACE,yBAAA;EACA,YAAA;AAjCN;;AA0CA,2BAAA;AACA;EACE;IACE,gBAAA;EAvCF;EAyCE;IACE,iBAAA;EAvCJ;AACF;AA2CA;EACE;IACE,aAAA;IACA,eAAA;EAzCF;EA2CE;IACE,iBAAA;EAzCJ;EA4CE;IACE,sBAAA;IACA,YAAA;EA1CJ;EA4CI;IACE,WAAA;IACA,gBAAA;EA1CN;EA+CI;IACE,kBAAA;EA7CN;EA+CM;IACE,qBAAA;EA7CR;EAgDM;IACE,WAAA;EA9CR;EAiDM;IACE,iBAAA;IACA,qBAAA;EA/CR;AACF","sourcesContent":[":root {\n  --primary-dark: #2563eb;\n  --secondary-color: #10b981; // A vibrant green\n  --secondary-dark: #059669;\n  --text-color: #374151;\n  --text-light: #6b7280;\n  --border-color: #e5e7eb;\n  --bg-light: #f9fafb;\n  --bg-medium: #f3f4f6;\n  --bg-dark: #e5e7eb;\n}\n\n.hier-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 1rem; // Add padding for smaller screens\n}\n\n.hier-modal {\n  background: #ffffff;\n  border-radius: 0.75rem;\n  width: 100%;\n  max-width: 600px; // Slightly reduced max-width for better focus\n  max-height: 85vh; // Increased max-height\n  overflow: hidden;\n  padding: 1.5rem;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);\n  display: flex;\n  flex-direction: column;\n  gap: 1rem; // Spacing between elements\n\n  h2 {\n    font-weight: 800;\n    font-size: 1.4rem;\n    text-align: center;\n    margin-bottom: 1rem;\n    color: var(--primary-color);\n    user-select: none;\n    padding-bottom: 0.5rem;\n    border-bottom: 2px solid var(--border-color);\n  }\n\n  .hier-modal-content {\n    flex-grow: 1;\n    overflow-y: auto;\n    padding-right: 0.75rem; // More padding for scrollbar\n    padding-bottom: 1rem; // Padding at the bottom\n    color: var(--text-color);\n    font-size: 0.95rem;\n\n    // Custom Scrollbar for better aesthetics\n    &::-webkit-scrollbar {\n      // width: 8px;\n\n    }\n\n    &::-webkit-scrollbar-track {\n      background: var(--bg-medium);\n      border-radius: 10px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: var(--primary-color);\n      border-radius: 10px;\n      height: 8px;\n\n      &:hover {\n        background: var(--primary-dark);\n      }\n    }\n\n    .tree-node {\n      position: relative;\n      padding-left: 1.5rem; // Base indentation for all nodes\n      margin-bottom: 0.25rem; // Smaller margin for denser tree\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n\n      .node-content {\n        display: flex;\n        align-items: center;\n        background-color: var(--bg-light);\n        padding: 0.5rem 0.75rem;\n        border-radius: 0.375rem; // Slightly smaller border-radius\n        border: 1px solid var(--border-color);\n        transition: background-color 0.2s ease, border-color 0.2s ease;\n        min-height: 40px; // Ensure consistent height\n\n        &:hover {\n          background-color: var(--bg-medium);\n          border-color: var(--primary-color);\n        }\n      }\n\n      .expand-icon {\n        width: 1rem;\n        height: 1rem;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n        margin-right: 0.5rem;\n        color: var(--text-light);\n        transition: transform 0.2s ease;\n        flex-shrink: 0;\n\n        svg {\n          width: 100%;\n          height: 100%;\n        }\n\n        &.expanded {\n          transform: rotate(90deg);\n        }\n      }\n\n      .node-label {\n        display: flex;\n        align-items: center;\n        gap: 0.75rem; // Slightly reduced gap\n        cursor: pointer;\n        flex-grow: 1; // Allow label to take available space\n\n        input[type=\"checkbox\"] {\n          // width: 20px;\n          // height:20px ;\n          cursor: pointer;\n          accent-color: var(--primary-color);\n          border-radius: 4px;\n          flex-shrink: 0;\n        }\n\n        .node-name {\n          font-weight: 600;\n          white-space: nowrap;\n          overflow: hidden;\n          color: #374151;\n          text-overflow: ellipsis; // Truncate long names\n          flex-grow: 1; // Allows name to take space\n        }\n\n        .node-role {\n          background: var(--secondary-color); // Use secondary color\n          color: #374151;\n          font-size: 0.7rem; // Smaller role font\n          font-weight: 600;\n          padding: 0.2rem 0.6rem;\n          border-radius: 9999px;\n          user-select: none;\n          flex-shrink: 0; // Prevent role from shrinking\n        }\n      }\n\n      .node-children {\n        margin-left: 1.5rem; // Indentation for children\n        padding-left: 1rem; // Space for the vertical line\n        border-left: 1px dashed var(--border-color); // Vertical hierarchy line\n        margin-top: 0.25rem; // Space between parent and children block\n      }\n\n      // Drawing horizontal lines\n      &::before {\n        content: \"\";\n        position: absolute;\n        left: 0.75rem; // Matches half of padding-left of .tree-node\n        top: 1.25rem; // Vertical center of the node-content\n        width: 0.75rem; // Length of the horizontal line\n        height: 1px;\n        background-color: var(--border-color);\n        // Only show horizontal line if it's not the root or the first child of its parent\n        // This is tricky with pure CSS. Often easier to manage with a class or JS.\n        // For simplicity, we'll draw it for all for now or rely on indentation.\n      }\n\n      .node-children>.tree-node::before {\n        background-color: var(--border-color);\n      }\n    }\n  }\n\n  .hier-modal-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 1rem;\n    padding-top: 1rem;\n    border-top: 1px solid var(--border-color);\n\n    button {\n      padding: 0.5rem 1rem;\n      font-size: 0.9rem;\n      font-weight: 700;\n      border: none;\n      border-radius: 0.5rem;\n      cursor: pointer;\n      transition: background-color 0.25s ease, transform 0.1s ease;\n\n      &:active {\n        transform: translateY(0);\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n      }\n    }\n\n    .hier-modal-submit-btn {\n      background-color: var(--primary-color);\n      color: white;\n    }\n\n    .hier-modal-close-btn {\n      background-color: #6c757d; // A neutral grey for close\n      color: white;\n\n      // &:hover {\n      //   background-color: #5a6268;\n      // }\n    }\n  }\n}\n\n/* Responsive Adjustments */\n@media (max-width: 768px) {\n  .hier-modal-overlay .hier-modal {\n    padding: 1.25rem;\n\n    h2 {\n      font-size: 1.5rem;\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .hier-modal-overlay .hier-modal {\n    padding: 1rem;\n    margin: 0.75rem; // Adjusted margin for smaller screens\n\n    h2 {\n      font-size: 1.3rem;\n    }\n\n    .hier-modal-actions {\n      flex-direction: column;\n      gap: 0.75rem;\n\n      button {\n        width: 100%;\n        min-width: unset; // Remove min-width on small screens\n      }\n    }\n\n    .hier-modal-content {\n      .tree-node {\n        padding-left: 1rem; // Reduce base indentation\n\n        .expand-icon {\n          margin-right: 0.25rem;\n        }\n\n        .node-label {\n          gap: 0.5rem;\n        }\n\n        .node-children {\n          margin-left: 1rem; // Reduce child indentation\n          padding-left: 0.75rem;\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
